export default __webpack_public_path__ + "static/media/keplr-icon.bd4d72f0.svg";